<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app,body,html {
  width: 100%;
  background: #f7f6ef !important;
}
[v-cloak] {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue